import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';
import * as R from 'ramda';

const initialState = {
  error: false,
  products: {
    data: [],
    fetching: false,
  },
  agencies: {
    data: [],
    fetching: false,
  },
  currentProduct: {
    form_data: {},
    product_data: {},
    required_fields: [],
    transforms: {},
    fetching: false,
  },
};

// Uncomment the below object to see PoC for item options enhancements w/o the backend
/**
const mockedFetchProductByIdResponseData = {
  status: 'success',
  product_data: {
    unit_price: '35.0',
    quantity: 1,
    item_lookup_source_id: 1,
    name: 'Dog Registration',
    receivable_type: 'PERMITS_AND_LICENSES',
    receivable_category: 'ANIMALS',
    source_system: null,
    service_type: 'permits',
    editable_quantity: false,
    validated: false,
    accepts_overpayment: false,
    accepts_underpayment: false,
    config: {
      metadata: {
        dept_code: '232076',
        fund_code: '10000',
        settle_code: 'cville-animals',
        account_code: '460124',
        project_code: '10026677',
        activity_code: '0001',
        authority_code: '10000',
      },
      detail_display: ['Owner Name', 'Pet Name', 'Dog Breed', 'Zip Code'],
      receipt_display: ['Owner Name', 'Pet Name', 'Dog Breed', 'Zip Code'],
    },
  },
  form_data: {
    owner_name: {
      type: 'string',
      name: 'Owner Name',
      display_name: 'Owner Name',
      title: 'Owner Name',
    },
    pet_name: {
      type: 'string',
      name: 'Pet Name',
      display_name: 'Pet Name',
      title: 'Pet Name',
    },
    dog_breed: {
      type: 'string',
      name: 'Dog Breed',
      display_name: 'Dog Breed',
      title: 'Dog Breed',
      oneOf: [
        {
          type: 'string',
          title: 'Royal Poodle $36.00',
          enum: ['Royal Poodle'],
        },
        {
          type: 'string',
          title: 'Standard Poodle $37.00',
          enum: ['Standard Poodle'],
        },
        {
          type: 'string',
          title: 'Mini Poodle $38.00',
          enum: ['Mini Poodle'],
        },
        {
          type: 'string',
          title: 'Toy Poodle $39.00',
          enum: ['Toy Poodle'],
        },
        {
          type: 'string',
          title: 'Teacup Poodle $40.00',
          enum: ['Teacup Poodle'],
        },
        {
          type: 'string',
          title: 'French Bulldogs $41.00',
          enum: ['French Bulldogs'],
        },
        {
          type: 'string',
          title: 'Bulldogs $42.00',
          enum: ['Bulldogs'],
        },
        {
          type: 'string',
          title: 'Labrador Retrievers $43.00',
          enum: ['Labrador Retrievers'],
        },
        {
          type: 'string',
          title: 'Golden Retrievers $44.00',
          enum: ['Golden Retrievers'],
        },
        {
          type: 'string',
          title: 'German Shepherd Dogs $45.00',
          enum: ['German Shepherd Dogs'],
        },
        {
          type: 'string',
          title: 'Rottweilers $46.00',
          enum: ['Rottweilers'],
        },
        {
          type: 'string',
          title: 'Beagles $47.00',
          enum: ['Beagles'],
        },
        {
          type: 'string',
          title: 'Pug $48.00',
          enum: ['Pug'],
        },
      ],
    },
    zip_code: {
      type: 'string',
      name: 'Zip Code',
      display_name: 'Zip Code',
      title: 'Zip Code',
    },
    amount: {
      editable: false,
      type: 'string',
      title: 'Payment Amount',
      default: '35.00',
    },
    quantity: {
      editable: false,
      type: 'number',
      title: 'Quantity',
      default: 1,
    },
    gl_code: {
      editable: false,
      type: 'string',
      title: 'GL Code',
    },
  },
  required_fields: ['amount', 'quantity'],
  transforms: {
    replace: {
      dog_breed: [
        {
          trigger: 'Royal Poodle',
          field: 'amount',
          value: '36.00',
        },
        {
          trigger: 'Royal Poodle',
          field: 'gl_code',
          value: 'royalpoo_123',
        },
        {
          trigger: 'Standard Poodle',
          field: 'amount',
          value: '37.00',
        },
        {
          trigger: 'Standard Poodle',
          field: 'gl_code',
          value: 'stapoo_123',
        },
        {
          trigger: 'Mini Poodle',
          field: 'amount',
          value: '38.00',
        },
        {
          trigger: 'Mini Poodle',
          field: 'gl_code',
          value: 'minipoo_123',
        },
        {
          trigger: 'Toy Poodle',
          field: 'amount',
          value: '39.00',
        },
        {
          trigger: 'Toy Poodle',
          field: 'gl_code',
          value: 'toypoo_123',
        },
        {
          trigger: 'Teacup Poodle',
          field: 'amount',
          value: '40.00',
        },
        {
          trigger: 'Teacup Poodle',
          field: 'gl_code',
          value: 'teapoo_123',
        },
        {
          trigger: 'French Bulldogs',
          field: 'amount',
          value: '41.00',
        },
        {
          trigger: 'French Bulldogs',
          field: 'gl_code',
          value: 'frenchbull_123',
        },
        {
          trigger: 'Labrador Retrievers',
          field: 'amount',
          value: '42.00',
        },
        {
          trigger: 'Labrador Retrievers',
          field: 'gl_code',
          value: 'labradors_123',
        },
        {
          trigger: 'Golden Retrievers',
          field: 'amount',
          value: '44.00',
        },
        {
          trigger: 'Golden Retrievers',
          field: 'gl_code',
          value: 'goldens_123',
        },
        {
          trigger: 'German Shepherd Dogs',
          field: 'amount',
          value: '45.00',
        },
        {
          trigger: 'German Shepherd Dogs',
          field: 'gl_code',
          value: 'goldens_123',
        },
        {
          trigger: 'Bulldogs',
          field: 'amount',
          value: '42.00',
        },
        {
          trigger: 'Bulldogs',
          field: 'gl_code',
          value: 'bullies_123',
        },
        {
          trigger: 'Rottweilers',
          field: 'amount',
          value: '46.00',
        },
        {
          trigger: 'Rottweilers',
          field: 'gl_code',
          value: 'rottweilers_123',
        },
        {
          trigger: 'Beagles',
          field: 'amount',
          value: '47.00',
        },
        {
          trigger: 'Beagles',
          field: 'gl_code',
          value: 'beagles_123',
        },
        {
          trigger: 'Pug',
          field: 'amount',
          value: '48.00',
        },
        {
          trigger: 'Pug',
          field: 'gl_code',
          value: 'beagles_123',
        },
      ],
    },
  },
};
*/
export const FETCH_LOOKUP_BY_ID = 'products/FETCH_LOOKUP_BY_ID';
export const fetchLookupById = (id) => ({
  type: FETCH_LOOKUP_BY_ID,
  payload: id,
});
export const FETCH_SEARCH_BY_ID = 'products/FETCH_SEARCH_BY_ID';
export const fetchSearchById = (id) => ({
  type: FETCH_SEARCH_BY_ID,
  payload: id,
});
export const FETCH_LOOKUP_BY_ID_SUCCESS = 'products/FETCH_LOOKUP_BY_ID_SUCCESS';
export const fetchLookupByIdSuccess = (data) => ({
  type: FETCH_LOOKUP_BY_ID_SUCCESS,
  payload: data,
});
export const FETCH_SEARCH_BY_ID_SUCCESS = 'products/FETCH_SEARCH_BY_ID_SUCCESS';
export const fetchSearchByIdSuccess = (data) => ({
  type: FETCH_SEARCH_BY_ID_SUCCESS,
  payload: data,
});
export const FETCH_PRODUCTS = 'products/FETCH_PRODUCTS';
export const fetchProducts = () => ({
  type: FETCH_PRODUCTS,
});
export const FETCH_AGENCIES = 'agencies/FETCH_AGENCIES';
export const fetchAgencies = () => ({
  type: FETCH_AGENCIES,
});
export const FETCH_PRODUCTS_SUCCESS = 'products/FETCH_PRODUCTS_SUCCESS';
export const fetchProductsSuccess = (data) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: data,
});
export const FETCH_AGENCIES_SUCCESS = 'agencies/FETCH_AGENCIES_SUCCESS';
export const fetchAgenciesSuccess = (data) => ({
  type: FETCH_AGENCIES_SUCCESS,
  payload: data,
});
export const FETCH_LOOKUP_BY_ID_FAILURE = 'products/FETCH_LOOKUP_BY_ID_FAILURE';
export const fetchLookupByIdFailure = () => ({
  type: FETCH_LOOKUP_BY_ID_FAILURE,
});
export const FETCH_SEARCH_BY_ID_FAILURE = 'products/FETCH_SEARCH_BY_ID_FAILURE';
export const fetchSearchByIdFailure = () => ({
  type: FETCH_SEARCH_BY_ID_FAILURE,
});
export const FETCH_PRODUCTS_FAILURE = 'products/FETCH_PRODUCTS_FAILURE';
export const fetchProductsFailure = () => ({
  type: FETCH_PRODUCTS_FAILURE,
});
export const FETCH_AGENCIES_FAILURE = 'agencies/FETCH_AGENCIES_FAILURE';
export const fetchAgenciesFailure = () => ({
  type: FETCH_AGENCIES_FAILURE,
});
export const CLEAR_CURRENT_PRODUCT = 'CLEAR_CURRENT_PRODUCT';
export const clearCurrentProduct = () => ({
  type: CLEAR_CURRENT_PRODUCT,
});

export const _reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_LOOKUP_BY_ID:
      // Use the object in a comment by the real object for a PoC of the item options
      // enhancements w/o the backend
      return {
        ...state,
        currentProduct: {
          ...state.currentProduct, // ...mockedFetchProductByIdResponseData,
          fetching: true,
        },
      };
    case FETCH_SEARCH_BY_ID:
      return {
        ...state,
        currentProduct: {
          ...state.currentProduct,
          fetching: true,
        },
      };
    case FETCH_PRODUCTS:
      return {
        ...state,
        products: {
          ...state.products,
          fetching: true,
        },
      };
    case FETCH_AGENCIES:
      return {
        ...state,
        agencies: {
          ...state.agencies,
          fetching: true,
        },
      };
    case FETCH_LOOKUP_BY_ID_SUCCESS:
      // Use the object in a comment by the real object for a PoC of the item options
      // enhancements w/o the backend
      return {
        ...state,
        currentProduct: {
          ...payload, // ...mockedFetchProductByIdResponseData,
          fetching: false,
        },
      };
    case FETCH_SEARCH_BY_ID_SUCCESS:
      return {
        ...state,
        currentProduct: {
          ...payload,
          fetching: false,
        },
      };
    case CLEAR_CURRENT_PRODUCT:
      return {
        ...state,
        currentProduct: initialState.currentProduct,
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: {
          ...payload,
          fetching: false,
        },
      };
    case FETCH_AGENCIES_SUCCESS:
      return {
        ...state,
        agencies: {
          ...payload,
          fetching: false,
        },
      };
    case FETCH_LOOKUP_BY_ID_FAILURE:
      return {
        ...state,
        currentProduct: {
          ...state.products,
          fetching: false,
        },
        error: true,
      };
    case FETCH_SEARCH_BY_ID_FAILURE:
      return {
        ...state,
        currentProduct: {
          ...state.products,
          fetching: false,
        },
        error: true,
      };
    case FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        products: {
          ...state.products,
          fetching: false,
        },
      };
    case FETCH_AGENCIES_FAILURE:
      return {
        ...state,
        agencies: {
          ...state.agencies,
          fetching: false,
        },
      };
    default:
      return state;
  }
};

export const _mapStateToProps = (state) => {
  const currentAgencyInCart =
    R.pathOr('', 'cart', 'order', 'status', state) == 'completed'
      ? null
      : R.pathOr('', ['cart', 'order', 'agencies', 0, 'id'], state);
  return {
    currentProduct: state.products.currentProduct,
    products: state.products.products,
    agencies: state.products.agencies,
    currentAgencyInCart: currentAgencyInCart,
  };
};
export const _mapDispatchToProps = (dispatch) => ({
  fetchProducts: () => dispatch(fetchProducts()),
  fetchAgencies: () => dispatch(fetchAgencies()),
  clearCurrentProduct: () => dispatch(clearCurrentProduct()),
});

export const ALERT_BAR_ACTION = 'products/ALERT_BAR_ACTION';
export const productsAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    alertBars: {
      productsAlertBar: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
  },
  'products',
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
